import { findDemo } from '#app/features/portfolio/demos/registry.ts'
import { ProblemCapsule } from '#app/features/writing/components/problem-capsule.tsx'

// The demo-page counterpart to the capsule ArticleLayout renders for essays.
// Demos are Writings under the two-bucket rule and sit in the same flat list, so
// they carry the same "Hard problem / Approach" primer — before 2026-08-04 only
// the MDX essays did, and a reader who clicked a demo row got no framing at all.
//
// Copy lives on the DATA.demos entry rather than inline in the page so it sits
// beside the blurb and description it has to stay consistent with, and so
// portfolio.test.ts can assert every demo has one. Keyed by href because that is
// already each demo's unique identifier across the data file.
//
// `className` is a passthrough because the demo pages come in two shapes: the
// architecture write-ups (harness, pipeline) sit in a ReadingColumn, a plain div
// where the capsule's own `my-8` is the spacing; the interactive demos are wide
// flex columns with their own `gap`, so they pass `my-0 max-w-4xl` to drop the
// doubled margin and keep the measure readable at max-w-4xl.
export function DemoCapsule({
	href,
	className,
}: {
	href: string
	className?: string
}) {
	const demo = findDemo(href)
	if (!demo) return null
	return (
		<ProblemCapsule
			problem={demo.hardProblem}
			approach={demo.approach}
			className={className}
		/>
	)
}
